const chatBotStyles = {
    cardEmphasisBackgroundColor: "#E9E9E9",
    //rootHeight: "100%",
    //rootWidth: "100%",
    //hideScrollToEndButton: true,
    hideSendBox: false,
    hideUploadButton: true,
    bubbleBackground: "transparent",
    bubbleBorderColor: "transparent",
    bubbleBorderRadius: 8,
    bubbleBorderStyle: "solid",
    bubbleBorderWidth: 1,
    bubbleNubOffset: "bottom",
    bubbleNubSize: 10,
    bubbleMaxWidth: "100%",
    bubbleMinHeight: 30,
    bubbleMinWidth: 250,
    buublePadding: 10,
    bubbleTextColor: "Black",
    bubbleFromUserBackground: "#EBF6FF",
    bubbleFromUserBorderColor: "#EBF6FF",
    bubbleFromUserBorderRadius: 8,
    bubbleFromUserBorderStyle: "solid",
    bubbleFromUserBorderWidth: 1,
    bubbleFromUserNubOffset: 'bottom',
    bubbleFromUserNubSize: 10,
    bubbleFromUserTextColor: "black",
    bubbleImageMinHeight: "240px",
    bubbleImageMaxHeight:"240px",
    sendBoxBackground: "white",
    sendBoxButtonColor: "#0074D4",
    sendBoxButtonColorOnFocus: "#0067CC",
    sendBoxButtonColorOnHover: "#0067CC",
    sendBoxTextColor: "#666666",
    sendBoxBorderBottom: "solid 2px #0074D4",
    sendBoxBorderLeft: "solid 2px #0074D4",
    sendBoxBorderRight: "solid 2px #0074D4",
    sendBoxBorderTop: "solid 2px #0074D4",
    groupTimestamp: false,
    //sendTimeout: 20000,
    //sendTimeoutForAttachments: 120000,
    timestampColor: "#767676",
    timestampFormat: "relative",
    typingAnimationBackgroundImage: "none",
    typingAnimationWidth: 50,
    typingAnimationHeight: 22,
    bubbleFromBotBackground: "transparent",
    bubbleFromBotBorderColor: "transparent",
  };


  export default chatBotStyles